import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateVerbaPagamentoColumnDefinition
 */

type Props = {
  onActionEdit: (idItemVerba: number, openState: boolean) => void;
  onActionDelete: (idItemVerba: number, openState: boolean) => void;
};

export const GenerateVerbaPagamentoColumnDefinition = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "A";
      case 0:
        return "I";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeTipoClass = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'bg-[#45b6af] text-white py-[.1rem] px-[.4rem] font-normal';
      case 1: return 'bg-[#f3565d] text-white py-[.1rem] px-[.4rem] font-normal';
      default: return '';
    }
  }

  const computeTipoLabel = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'Acréscimo (+)';
      case 1: return 'Desconto (-)';
      default: return '';
    }
  }

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      width: 135,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <span className={computeTipoClass(params.value)}>
              {computeTipoLabel(params.value)}
            </span>
          </div>
        );
      },
    },
    {
      field: "nrItemVerba",
      filterable: false,
      headerName: "Nº",
      width: 100,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Verba",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "valorItemVerba",
      filterable: false,
      headerName: "Valor",
      width: 200,
      minWidth: 200,
      sortable: false,
      renderCell: ({ value }) => <div>{value && `R$ ${value.toFixed(2)}`}</div>,
    },
    {
      field: 'idItemVerba',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}